import React from 'react'
import POSBillingSofrware from '../POSBillingSofrware/POSBillingSofrware'

const Home = () => {
  document.title = 'MACRUM | Home'

  return (
    <div>
      <POSBillingSofrware />
    </div>
  )
}

export default Home
